import React, {Component} from "react";
import axios from "axios";
import { api_link } from "siteConfig";

// reactstrap components
import { Card, CardFooter, CardHeader, CardBody, Row, Col, CardTitle, Table, Button, Input, InputGroup, InputGroupAddon, InputGroupText } from "reactstrap";

// core components
import PanelHeader from "components/PanelHeader/PanelHeader.js";
import image from "Main_Image.jpg";
import loading_image from "loading_animation.gif";

class FileStore extends Component {
    constructor(props) {
        super(props);
        
        this.state = {
            files: [],
            loading: true,
            searchTerm: ''
        };
    }

    async componentDidMount() {

        this.loadFileStore().then((resp) => {
            console.log('File Store Loaded')
            this.setState({files: resp, loading: false})
        })

    }

    loadFileStore = async () => {
        var url = 'https://'+api_link+'customer_portal_v2/getFiles'
        var contract_id = sessionStorage.getItem("contract_id")

        let files = await axios({
            method: "post",
            url: url,
            data: {
                "referurl": url,
                "var1": contract_id
            },
            timeout: 5000,
            headers: {
                "api-key": "ad8acb-e20326-93d0b2-11e5f2-d78c2e",
                // "Access-Control-Allow-Origin": "*",
                "Content-Type": "application/json"
            }
        }).then(resp => {
            console.log(resp)
            return resp.data
        }).catch(err => {
            console.log(err)
        })

        return files
    }

    async downloadFile(filename) {
        let url = 'https://api.jcwes.com/v1.0/live/customer_portal_v2/downloadFileStore'

        try {
          axios({
                method: "post",
                url: url,
                data: {
                    "referurl": url,
                    "var1": filename,
                },
                headers: {
                    "api-key": "ad8acb-e20326-93d0b2-11e5f2-d78c2e",
                    // "Access-Control-Allow-Origin": "*",
                    "Content-Type": "application/json"
                }
            }).then(resp => {
                const pdfData = atob(resp.data.content);
                const bytes = new Uint8Array(pdfData.length);
                for (let i = 0; i < pdfData.length; i++) {
                    bytes[i] = pdfData.charCodeAt(i);
                }
                let file = new Blob([bytes], {type:  resp.data.mime});

                //download file
                let fileURL = URL.createObjectURL(file);

                console.log(fileURL)

                let a = document.createElement('a');
                a.href = fileURL;
                a.download = resp.data.name;
                a.click();
            }).catch(err => {
                console.log(err)
            });
        } catch (error) {
            console.error('Download failed:', error);
        }
    }

    render() {

        return (
        <>
            <PanelHeader
                size="lg"
                content={image}
            />
            <div className="content" style={{marginTop: '-270px'}}>
            <Row>
                <Col xs={12} md={12}>
                    <Card>
                    <CardHeader>
                        {/* <h5 className="card-category">Stats / Other Bits</h5> */}
                        <CardTitle tag="h4">Filestore</CardTitle>
                    </CardHeader>
                    <CardBody>
                        <p>Any files uploaded by JCW will be available here.</p>
                        <center><img src={loading_image} alt="loading" style={this.state.loading ? {display: ''} : {display: 'none'}} /></center>
                        <InputGroup className="no-border">
                            <Input style={{ color: 'black' }} placeholder="Search..." onChange={(e) => this.setState({ searchTerm: e.target.value })} />
                            <InputGroupAddon addonType="append">
                                <InputGroupText>
                                    <i className="now-ui-icons ui-1_zoom-bold" />
                                </InputGroupText>
                            </InputGroupAddon>
                        </InputGroup>
                        <Table style={this.state.loading === false ? {display: ''} : {display: 'none'}}>
                            <thead>
                                <th>Title</th>
                                <th>Description</th>
                                <th></th>
                            </thead>
                            <tbody>
                                {
                                    this.state.files && this.state.files.filter(file => {
                                        return file.title.toLowerCase().includes(this.state.searchTerm.toLowerCase()) || file.description.toLowerCase().includes(this.state.searchTerm.toLowerCase());
                                    }).map((file, index) => {
                                        return (
                                            <tr key={index}>
                                                <td>{file.title}</td>
                                                <td>{file.description}</td>
                                                <td>
                                                    <Button 
                                                        color="primary"
                                                        className="btn-round"
                                                        onClick={() => this.downloadFile(file.filename)}
                                                    >Download</Button>
                                                </td>
                                            </tr>
                                        )
                                    })
                                }
                            </tbody>
                        </Table>
                    </CardBody>
                    <CardFooter>

                    </CardFooter>
                    </Card>
                </Col>
            </Row>
            </div>
        </>
        );
    }
}

export default FileStore;